export default __webpack_public_path__ + "static/media/bola.00a5c8a3.mp4";